import React from "react";
import { Create, SimpleForm, TextInput } from "react-admin";

export const TermsCreate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="title" />
        <TextInput source="description" />
      </SimpleForm>
    </Create>
  );
};
